









import { defineComponent, useContext, computed } from '@nuxtjs/composition-api';
import { getProductColorFromType } from '~/utils/modules/products';

export default defineComponent({
  props: {
    wineType: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    // バーのレベル最大値
    const BAR_MAX_LEVEL = 5;
    const {
      app: { $C },
    } = useContext();

    const gradientColor = computed(() => {
      const colorType = getProductColorFromType(props.wineType);
      const colors = $C.PRODUCT_WINE_BAR_COLORS[colorType];

      if (!colors) {
        return;
      }

      return `no-repeat linear-gradient(to right, ${colors.from}, ${colors.to})`;
    });

    const gradientValue = computed(() => {
      const start = ((props.value - 1) / BAR_MAX_LEVEL) * 100;
      const end = 100 - (props.value / BAR_MAX_LEVEL) * 100;
      return `inset(0 ${end}% 0 calc(${start}% + 1px) round 2px)`;
    });

    return {
      BAR_MAX_LEVEL,
      gradientColor,
      gradientValue,
    };
  },
});
